// auth.js: Utility for checking authentication and role
export function isAuthenticated() {
  const token = localStorage.getItem('token');
  return !!token;
}

export function getUserRoles() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const raw = user.role || '';
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map(r => String(r).trim().toLowerCase());
  if (typeof raw === 'string') return raw.split(/[,;|]/).map(r => String(r).trim().toLowerCase()).filter(Boolean);
  return [String(raw).trim().toLowerCase()];
}

// Backwards compat: default export for single role (first)
export function getUserRole() {
  const roles = getUserRoles();
  return roles[0] || null;
}
